import dialogCreaCliente from  './dialogCreaCliente'
import estrattoConto from './estratto-conto'
import estrattoContoDettagliato from './estratto-conto-dettagliato'
import sollecito from './sollecito'
import preavviso from './preavviso'
// import messaInMora from './messa-in-mora'
import messaInMoraPec from './messa-in-mora-pec'
import massivoSDI from './massivo-sdi'
import cambioRappresentante from './cambio-rappresentante'
// import invitoAutoletturaMail from './invito-autolettura-mail'

export default [
  // always
  {
    'key': 'dialogCreaCliente',
    'label': 'Crea Nuovo Cliente',
    'classCss': 'p-button-secondary',
    icon: " pi pi-plus",
    'type': 'operation',
    'method': dialogCreaCliente,
    'display': 'always'
  },
  // {
  //   'key': 'button-clienti-invito-autolettura',
  //   'label': 'INVITO AUTOLETTURA MAIL',
  //   'classCss': 'p-button-warning',
  //   'icon': ' pi pi-envelope',
  //   'type': 'operation',
  //   'method': invitoAutoletturaMail,
  //   'display': 'always'
  // },

  // on-data-filtered
  {
    key: 'clienti-cambio-rappresentante',
    label: 'Cambia Rappresentante',
    classCss: 'p-button-secondary',
    icon: 'pi pi-user-edit',
    type: 'operation',
    method: cambioRappresentante,
    display: 'on-non-domestic-clients-filtered'
  },
  {
    'key': 'clienti-button-estratto-conto',
    'label': 'ESTRATTO CONTO',
    'classCss': 'p-button-secondary',
    'icon': ' pi pi-directions',
    'type': 'operation',
    'method': estrattoConto,
    'display': 'on-data-filtered'
  },
  {
    'key': 'clienti-button-estratto-conto-dettagliato',
    'label': 'ESTRATTO CONTO DETTAGLIATO',
    'classCss': 'p-button-secondary',
    'icon': ' pi pi-directions',
    'type': 'operation',
    'method': estrattoContoDettagliato,
    'display': 'on-data-filtered'
  },
  {
    'key': 'clienti-button-sollecito',
    'label': 'SOLLECITO',
    'classCss': 'p-button-secondary',
    'icon': ' pi pi-directions',
    'type': 'operation',
    'method': sollecito,
    'display': 'on-data-filtered'
  },
  {
    'key': 'clienti-button-preavviso',
    'label': 'PREAVVISO',
    'classCss': 'p-button-secondary',
    'icon': ' pi pi-directions',
    'type': 'operation',
    'method': preavviso,
    'display': 'on-data-filtered'
  },
  {
    'key': 'clienti-button-messa-in-mora-pec',
    'label': 'MESSA IN MORA',
    'classCss': 'p-button-secondary',
    'icon': ' pi pi-calendar-times',
    'type': 'operation',
    'method': messaInMoraPec,
    'display': 'on-data-filtered'
  },
  {
    'key': 'massivoSDI',
    'label': 'CARICAMENTO MASSIVO SDI',
    'classCss': 'p-button-secondary',
    'icon': ' pi pi-calendar-times',
    'type': 'operation',
    'method': massivoSDI,
    'display': 'on-data-filtered'
  },
]
